import type { WeddingData } from './types'

export type VenueSource =
  | { type: 'custom'; name: string; address: string; private: boolean }
  | { type: 'supplier'; supplierId: string }

export type Venue = {
  id: string
  source: VenueSource
  uses: string[]
  availableFrom: string
  availableTo: string
  handoverTime: string
  handover: string
  included: string
  restrictions: string
  parking: string
  access: string
  accessibility: string
  accommodation: string
  notes: string
  documents: { id: string; file: File }[]
}

export function emptyVenue(id: string, source: VenueSource): Venue {
  return {
    id,
    source,
    uses: [],
    availableFrom: '',
    availableTo: '',
    handoverTime: '',
    handover: '',
    included: '',
    restrictions: '',
    parking: '',
    access: '',
    accessibility: '',
    accommodation: '',
    notes: '',
    documents: [],
  }
}

export function planningVenues(): Venue[] {
  return [
    {
      ...emptyVenue('loucen', { type: 'supplier', supplierId: 'sup-loucen' }),
      uses: ['Obřad', 'Hostina a oslava'],
      availableFrom: '2027-06-11',
      availableTo: '2027-06-13',
      included: 'Židle pro obřad, stoly a nábytek v sále. Úklid po akci.',
      restrictions: 'Svíčky jen ve skleněných svícnech. Venkovní hudba do 22:00.',
      parking: 'Hosté parkují u hlavní brány. Dvě místa u vstupu necháme pro rodinu.',
      notes: 'V pátek přivezeme dekorace, v neděli dopoledne vyzvedneme zbytek věcí.',
    },
    {
      ...emptyVenue('parents', {
        type: 'custom',
        name: 'U rodičů',
        address: 'Lipová 18, Loučeň',
        private: true,
      }),
      uses: ['Přípravy'],
      notes: 'Klidné ráno před obřadem. Líčení, oblékání a první společné fotky.',
    },
  ]
}

export function venueIdentity(venue: Venue, data: WeddingData) {
  if (venue.source.type === 'custom') return { ...venue.source, supplier: undefined }
  const supplierId = venue.source.supplierId
  const supplier = data.suppliers.find((item) => item.id === supplierId)
  const catalog = data.catalog.find((item) => item.id === supplier?.catalogServiceId)
  return {
    name: supplier?.name ?? 'Nedostupný dodavatel',
    address: catalog?.profile?.address ?? supplier?.profile?.address ?? '',
    private: false,
    supplier,
  }
}
